import { DeleteOutlined } from '@ant-design/icons'
import { useQueries } from '@tanstack/react-query'
import { Button, List } from 'antd'
import { FormInstance } from 'antd/lib'

import { usePersonsServiceGetPersonByIdEndpointKey } from 'src/api/queries'
import { GetPotentialContactResponse, PersonsService } from 'src/api/requests'

import { ContactsListItem } from './ContactsListItem'
import { useStyles } from './styles'

type Props = {
  form: FormInstance
}

export const ContactsList = ({ form }: Props) => {
  const { styles } = useStyles()

  const contacts =
    (form.getFieldValue('contactsList') as GetPotentialContactResponse[]) ?? []

  const personsQueries = useQueries({
    queries: contacts?.map((contact) => ({
      queryKey: [usePersonsServiceGetPersonByIdEndpointKey, contact.personId],
      queryFn: () =>
        PersonsService.getPersonByIdEndpoint(String(contact?.personId))
    }))
  })

  const personsData = personsQueries?.flatMap((person) => person.data)

  const contactsData = contacts.map((contact) => {
    const person = personsData.find((person) => person?.id === contact.personId)

    return {
      contactDate: contact?.contactDate,
      comments: contact?.comments,
      person: {
        firstName: person?.firstName,
        lastName: person?.lastName
      }
    }
  })

  const onDelete = (index: number) => {
    const newContacts = [...contacts]

    newContacts.splice(index, 1)
    form.setFieldValue('contactsList', newContacts)
  }

  return (
    <div className={styles.contactsList}>
      <List
        itemLayout="horizontal"
        dataSource={contactsData}
        className="full-width"
        renderItem={(contact, index) => (
          <ContactsListItem contact={contact}>
            <Button
              icon={<DeleteOutlined />}
              danger
              onClick={() => onDelete(index)}
            />
          </ContactsListItem>
        )}
      />
    </div>
  )
}
